import React, { useState } from "react";
import { Link } from "react-router-dom";
import Head from "./Head";
import "./header.css";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

const Header = () => {
  const [click, setClick] = useState(false);

  return (
    <>
      <Head />
      <header>
        <nav className="flexSB">
          <ul
            className={click ? "mobile-nav" : "flexSB "}
            onClick={() => setClick(false)}
          >
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/our-services">Our Services</Link>
            </li>

            <li>
              <Link to="/contact-us">Contact Us</Link>
            </li>
            <li>
              <Link to="/about-us">About Us</Link>
            </li>
          </ul>

          <button className="toggle" onClick={() => setClick(!click)}>
            {click ? (
              <CloseIcon sx={{ fontSize: 50 }} />
            ) : (
              <MenuIcon sx={{ fontSize: 50 }} />
            )}
          </button>
        </nav>
      </header>
    </>
  );
};

export default Header;
